/**
 * Card Component
 * Basic card container with border and padding
 */

import styled from '@emotion/styled';

export interface CardProps {
  children: React.ReactNode;
  padding?: 'sm' | 'md' | 'lg';
  noBorder?: boolean;
}

const StyledCard = styled.div<{ padding: string; noBorder: boolean }>`
  background: ${({ theme }) => theme.colors.background.primary};
  border: ${({ noBorder, theme }) =>
    noBorder ? 'none' : `1px solid ${theme.colors.border.color}`};
  border-radius: ${({ theme }) => theme.radius.regular};
  padding: ${({ padding, theme }) => theme.space[padding]};
`;

export function Card({ children, padding = 'lg', noBorder = false }: CardProps) {
  return (
    <StyledCard padding={padding} noBorder={noBorder}>
      {children}
    </StyledCard>
  );
}
